class FacetsFilterForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#facets-wrapper');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetsFilterForm.searchParamsInitial;
      if (searchParams === FacetsFilterForm.searchParamsPrev) return;
      FacetsFilterForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {

    // Uncheck filter inputs when clear filters button is clicked
    if ( disable == true ) {
      document.querySelectorAll('.facets-wrap input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = false; 
        checkbox.removeAttribute('checked');
        checkbox.classList.remove('mouse-focused');
      });
    }

    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetsFilterForm.searchParamsPrev = searchParams;
    const sections = FacetsFilterForm.getSections()
    //const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('product-count-desktop');

    // Hide product count when filtering products
    document.querySelector('.product-count').style.display = 'none';

    // Show spinner when filtering products
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('product-view-container').classList.add('loading');
    //if (countContainer) {
      //countContainer.classList.add('loading');
    //}
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetsFilterForm.filterData.some(filterDataUrl)
        ? FacetsFilterForm.renderSectionFromCache(filterDataUrl, event)
        : FacetsFilterForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetsFilterForm.updateURLHash(searchParams);
    
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetsFilterForm.filterData = [...FacetsFilterForm.filterData, { html, url }];
        FacetsFilterForm.renderFilters(html, event);
        FacetsFilterForm.renderProductViewContainer(html);
        FacetsFilterForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetsFilterForm.filterData.find(filterDataUrl).html;
    FacetsFilterForm.renderFilters(html, event);
    FacetsFilterForm.renderProductViewContainer(html);
    FacetsFilterForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductViewContainer(html) {

    // Check if grid-view or list-view has the 'hidden' class before rendering happens
    var gridView = document.querySelector('.grid-view');
    var listView = document.querySelector('.list-view');

    const isGridView = window.getComputedStyle(listView).display === 'none';
    const isListView = window.getComputedStyle(gridView).display === 'none';

    // Render new products based on filter selections
    document.getElementById('product-view-container').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-view-container').innerHTML;

    // Update grid view and list view element after rendering
    gridView = document.querySelector('.grid-view');
    listView = document.querySelector('.list-view');

    // If grid view was visible before rendering, then hide list view
    if (isGridView) {
      listView.style.display = 'none';
    }

    // If list view was visible before rendering, then hide grid view
    if (isListView) {
      gridView.style.display = 'none';
    }

    document.getElementById('product-view-container').classList.remove('loading');

    // Ensure collectionViewMode runs after updating the product grid 
    if (typeof window.collectionViewMode === 'function') { 
      window.collectionViewMode(); 
    } 
    
  }

  static renderProductCount(html) {

    // const count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-count').innerHTML;
    //const containerDesktop = document.getElementById('ProductCountDesktop');

    // Product count container
    const container = document.getElementById('product-count');

    // Parse the HTML string into a DOM object
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Select all elements with the class 'product-card' from the parsed HTML
    const products = parsedHTML.querySelectorAll('.product-card');

    // Count the number of selected product elements
    const filteredProductsCount = products.length; 

    // Check products length and set text
    let productsText = ''; 
    productsText = products.length > 1 ? 'tuotetta' : 'tuote';

    // Update the inner HTML of the container element with the count of filtered products and text
    container.innerHTML = filteredProductsCount + ' ' + productsText;

    container.classList.remove('loading');
    //if (containerDesktop) {
      //containerDesktop.innerHTML = count;
      //containerDesktop.classList.remove('loading');
    //}

    // Hide spinner after filtering products
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));

    // Show product count after filtering products
    document.querySelector('.product-count').style.display = 'block';

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#facets-filter-form .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#facets-filter-form .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    console.log(facetDetailsElementsFromFetch);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetsFilterForm.renderActiveFacets(parsedHTML);
    FacetsFilterForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {

      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetsFilterForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        //FacetsFilterForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets-summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetsFilterForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    //document.getElementById('facets-filter-form-mobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {

    const targetSummary = target.querySelector('.facets-summary');
    const sourceSummary = source.querySelector('.facets-summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets-header');
    const sourceHeaderElement = source.querySelector('.facets-header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  /*
  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }
  */

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('main-product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetsFilterForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'facets-filter-form-mobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'facets-filter-form' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'facets-filter-form-mobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetsFilterForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetsFilterForm.renderPage(url);
  }
}

FacetsFilterForm.filterData = [];
FacetsFilterForm.searchParamsInitial = window.location.search.slice(1);
FacetsFilterForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetsFilterForm);
FacetsFilterForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);